import AdminImg from "./assets/admin-img.svg";
import StarIcon from "@mui/icons-material/Star";
import { Rating, Tooltip } from "@mui/material";

import moment from "moment";

export const HomeColumns = [
  {
    field: "index",
    headerName: "#",
    minWidth: 40,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "name",
    headerName: "الاسم",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "phone",
    headerName: "رقم الموبايل",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "email",
    headerName: "البريد الالكتروني",
    minWidth: 220,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "created_at",
    headerName: "تاريخ و وقت التسجيل",
    minWidth: 220,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => {
      const dateStr = params?.row?.created_at;
      if (!dateStr) return "Invalid Date";

      // Handle the mixed format issue
      let cleanedDate = dateStr;

      // Check if it's 24-hour format with am/pm (invalid combination)
      const timeMatch = dateStr.match(/(\d{1,2}):(\d{2}):(\d{2})\s*(am|pm)/i);
      if (timeMatch) {
        const hour = parseInt(timeMatch[1]);
        // If hour > 12, remove am/pm as it's 24-hour format
        if (hour > 12) {
          cleanedDate = dateStr.replace(/\s*(am|pm)$/i, "");
        }
      }

      const momentDate = moment(cleanedDate);
      return momentDate.isValid()
        ? momentDate.format("YYYY-MM-DD hh:mm a")
        : "Invalid Date";
    },
  },
  {
    field: "register_type",
    headerName: "طريقة التسجيل",
    minWidth: 120,
    headerAlign: "center",
    align: "center",

    renderCell: (params) => {
      const registerTypes = {
        1: "رقم الهاتف",
        2: "Google",
        3: "Apple",
        4: "Facebook",
      };
      return (
        <span>{registerTypes[params?.row?.register_type] || "Normal"}</span>
      );
    },
  },
  {
    field: "orders_count",
    headerName: "عدد الطلبات",
    minWidth: 120, // Increased from 30 to be more readable
    headerAlign: "center",
    align: "center",
  },
];

export const VendorsOrdersColumns = [
  {
    field: "index",
    headerName: "#",
    minWidth: 40,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "vendor",
    headerName: "اسم المتجر",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => {
      const firstVendor = params?.row?.vendor?.name;
      return <span>{firstVendor || "غير موجود او تم حذفه"}</span>;
    },
  },
  {
    field: "total",
    headerName: "الاجمالي",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "discount",
    headerName: "الخصم",
    minWidth: 220,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "created_at",
    headerName: "تاريخ و وقت الشراء",
    minWidth: 160,
    headerAlign: "center",
    align: "center",

    renderCell: (params) =>
      moment(params?.row?.created_at).format("YYYY-MM-DD"),
  },
  // {
  //   field: "register_type",
  //   headerName: "طريقة التسجيل",
  //   minWidth: 120,
  //   headerAlign: "center",
  //   align: "center",
  //   sortable: false,
  //   renderCell: (params) => {
  //     const registerTypes = {
  //       1: "Normal",
  //       2: "Google",
  //       3: "Apple",
  //       4: "Facebook",
  //     };
  //     return <span>{registerTypes[params.row.register_type] || "Normal"}</span>;
  //   },
  // },
  {
    field: "status",
    headerName: "الحالة",
    minWidth: 160, // Increased from 30 to be more readable
    headerAlign: "center",
    align: "center",
  },
];

export const AddProductsColumns = [
  {
    field: "index",
    headerName: "#",
    minWidth: 40,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "image",
    headerName: "الصورة",
    minWidth: 60,
    headerAlign: "center",
    align: "center",

    renderCell: (params) => {
      return (
        <div className="cell-img">
          <img src={params?.row?.image} alt="" />
        </div>
      );
    },
  },
  {
    field: "name_ar",
    headerName: "اسم المنتج",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "logo",
    headerName: "الشعار",
    minWidth: 60,
    headerAlign: "center",
    align: "center",

    renderCell: (params) => {
      return (
        <div className="cell-img">
          <img src={params?.row?.vendor?.logo} alt="" />
        </div>
      );
    },
  },
  {
    field: "type",
    headerName: "نوع المؤسسة",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => {
      return (
        <span>{params?.row?.vendor?.type === "shop" ? "متجر" : "مصنع"}</span>
      );
    },
  },
  {
    field: "vendor",
    headerName: "اسم البائع",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => {
      return <span>{params?.row?.vendor?.name || "لا يوجد"}</span>;
    },
  },

  {
    field: "category",
    headerName: "القسم الرئيسي",
    minWidth: 160, // Increased from 30 to be more readable
    headerAlign: "center",
    align: "center",
    renderCell: (params) => {
      return <span>{params?.row?.category?.main_category || "لا يوجد"}</span>;
    },
  },

  {
    field: "orders_coun9",
    headerName: "القسم الفرعي-1",
    minWidth: 160, // Increased from 30 to be more readable
    headerAlign: "center",
    align: "center",
    renderCell: (params) => {
      return <span>{params?.row?.category?.sub_category || "لا يوجد"}</span>;
    },
  },
  // ناقصه
  {
    field: "orders_count8",
    headerName: "القسم الفرعي-2",
    minWidth: 160, // Increased from 30 to be more readable
    headerAlign: "center",
    align: "center",
    renderCell: (params) => {
      return (
        <span>{params?.row?.category?.sub_sub_category || "لا يوجد"}</span>
      );
    },
  },

  {
    field: "transaction_type",
    headerName: "نوع المعاملة",
    minWidth: 160, // Increased from 30 to be more readable
    headerAlign: "center",
    align: "center",
  },

  {
    field: "discount",
    headerName: "الخصم",
    minWidth: 160, // Increased from 30 to be more readable
    headerAlign: "center",
    align: "center",
  },

  {
    field: "discount_date_to",
    headerName: "تاريخ انتهاء الخصم",
    minWidth: 240,
    flex: 1,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => (
      <span>
        {params?.row?.discount_date_to
          ? moment(params?.row?.discount_date_to).format(
              "DD/MM/YYYY hh:mm:ss a",
            )
          : "-"}
      </span>
    ),
  },

  {
    field: "created_at4",
    headerName: "تاريخ و وقت الاضافة",
    minWidth: 160,
    headerAlign: "center",
    align: "center",

    renderCell: (params) =>
      moment(params?.row?.created_at).format("YYYY-MM-DD"),
  },

  {
    field: "stock",
    headerName: "الكمية المتاحة",
    minWidth: 160, // Increased from 30 to be more readable
    headerAlign: "center",
    align: "center",
  },
  // ناقصه
  {
    field: "unit_type",
    headerName: "وحدة الكمية",
    minWidth: 160, // Increased from 30 to be more readable
    headerAlign: "center",
    align: "center",
  },

  {
    field: "country",
    headerName: "نطاق العمل",
    minWidth: 160, // Increased from 30 to be more readable
    headerAlign: "center",
    align: "center",
  },
];

export const EditPartnersColumns = [
  {
    field: "index",
    headerName: "#",
    minWidth: 40,
    headerAlign: "center",
    align: "center",
  },

  {
    field: "logo",
    headerName: "الشعار",
    minWidth: 60,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => {
      return (
        <div className="cell-img">
          <img src={params?.row?.logo} alt="" />
        </div>
      );
    },
  },

  {
    field: "type",
    headerName: "نوع المؤسسة",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
    flex: 1,
    renderCell: (params) => {
      return <span>{params?.row?.type === "shop" ? "متجر" : "مصنع"}</span>;
    },
  },

  {
    field: "name",
    headerName: "الاسم",
    minWidth: 220,
    headerAlign: "center",
    align: "center",
    flex: 1,
  },

  {
    field: "phone",
    headerName: "رقم الموبايل",
    minWidth: 160, // Increased from 30 to be more readable
    headerAlign: "center",
    align: "center",
    flex: 1,
  },

  {
    field: "updated_at",
    headerName: "تاريخ و وقت التعديل",
    minWidth: 220,
    headerAlign: "center",
    align: "center",
    flex: 1,
    renderCell: (params) =>
      moment(params?.row?.updated_at).format("YYYY-MM-DD"),
  },
];

export const AddPartnersColumns = [
  {
    field: "index",
    headerName: "#",
    minWidth: 40,
    headerAlign: "center",
    align: "center",
  },

  {
    field: "logo",
    headerName: "الشعار",
    minWidth: 80,
    headerAlign: "center",
    align: "center",

    renderCell: (params) => {
      return (
        <div className="cell-img">
          <img src={params?.row?.logo} alt="" />
        </div>
      );
    },
  },

  {
    field: "type",
    headerName: "نوع المؤسسة",
    minWidth: 160,
    headerAlign: "center",
    align: "center",

    renderCell: (params) => {
      return <span>{params?.row?.type === "shop" ? "متجر" : "مصنع"}</span>;
    },
  },

  {
    field: "name",
    headerName: "الاسم",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
  },

  {
    field: "phone",
    headerName: "رقم الموبايل",
    minWidth: 160, // Increased from 30 to be more readable
    headerAlign: "center",
    align: "center",
  },

  {
    field: "email",
    headerName: "الايميل",
    minWidth: 120, // Increased from 30 to be more readable
    headerAlign: "center",
    align: "center",
  },

  {
    field: "country",
    headerName: "البلد",
    minWidth: 160, // Increased from 30 to be more readable
    headerAlign: "center",
    align: "center",
    // renderCell: (params) => (
    //   <span>{params?.row?.country.name_ar || "لا يوجد"}</span>
    // ),
  },

  {
    field: "government",
    headerName: "المحافظة",
    minWidth: 160, // Increased from 30 to be more readable
    headerAlign: "center",
    align: "center",
    renderCell: (params) => (
      <span>{params?.row?.governorate || "لا يوجد"}</span>
    ),
  },

  {
    field: "city",
    headerName: "المنطقه",
    minWidth: 160, // Increased from 30 to be more readable
    headerAlign: "center",
    align: "center",
    renderCell: (params) => <span>{params?.row?.city || "لا يوجد"}</span>,
  },

  {
    field: "working_scope",
    headerName: "نطاق العمل",
    minWidth: 160, // Increased from 30 to be more readable
    headerAlign: "center",
    align: "center",
    renderCell: (params) => (
      <span>{params?.row?.working_scope || "لا يوجد"}</span>
    ),
  },

  {
    field: "money_method",
    headerName: "طريقة استلام المستحقات",
    minWidth: 220, // Increased from 30 to be more readable
    headerAlign: "center",
    align: "center",
    renderCell: (params) => (
      <span>
        {params?.row?.acc_type === "Bank"
          ? "البطاقات الائتمانية"
          : "المحفظة الالكترونية" || "لا يوجد"}
      </span>
    ),
  },
];

export const ShopsColumns = [
  {
    field: "index",
    headerName: "#",
    minWidth: 40,
    headerAlign: "center",
    align: "center",
  },

  {
    field: "logo",
    headerName: "الشعار",
    minWidth: 80,
    headerAlign: "center",
    align: "center",

    renderCell: (params) => {
      return (
        <div className="cell-img">
          <img src={params?.row?.logo} alt="" />
        </div>
      );
    },
  },

  {
    field: "name",
    headerName: "اسم المتجر",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
  },

  {
    field: "phone",
    headerName: "رقم الموبايل",
    minWidth: 160, // Increased from 30 to be more readable
    headerAlign: "center",
    align: "center",
  },

  {
    field: "email",
    headerName: "الايميل",
    minWidth: 240, // Increased from 30 to be more readable
    headerAlign: "center",
    align: "center",
  },

  {
    field: "country",
    headerName: "البلد",
    minWidth: 160, // Increased from 30 to be more readable
    headerAlign: "center",
    align: "center",
  },

  {
    field: "governorate",
    headerName: "المحافظة",
    minWidth: 160, // Increased from 30 to be more readable
    headerAlign: "center",
    align: "center",
  },

  {
    field: "city",
    headerName: "المنطقة",
    minWidth: 160, // Increased from 30 to be more readable
    headerAlign: "center",
    align: "center",
  },

  {
    field: "rating",
    headerName: "التقييم الاجمالي",
    minWidth: 160, // Increased from 30 to be more readable
    headerAlign: "center",
    align: "center",
  },

  {
    field: "working_scope",
    headerName: "نطاق العمل",
    minWidth: 160, // Increased from 30 to be more readable
    headerAlign: "center",
    align: "center",
  },

  {
    field: "register_type",
    headerName: "طريقة التسجيل",
    minWidth: 160, // Increased from 30 to be more readable
    headerAlign: "center",
    align: "center",
  },

  {
    field: "created_at",
    headerName: "تاريخ و وقت التسجيل",
    minWidth: 160, // Increased from 30 to be more readable
    headerAlign: "center",
    align: "center",

    renderCell: (params) =>
      moment(params?.row?.created_at).format("YYYY-MM-DD"),
  },

  {
    field: "number_of_orders",
    headerName: "عدد الطلبات",
    minWidth: 160, // Increased from 30 to be more readable
    headerAlign: "center",
    align: "center",
  },

  {
    field: "number_of_products",
    headerName: "عدد المنتجات",
    minWidth: 160, // Increased from 30 to be more readable
    headerAlign: "center",
    align: "center",
  },

  {
    field: "favorites_count",
    headerName: "عدد مرات الاضافة للمفضلة",
    minWidth: 220, // Increased from 30 to be more readable
    headerAlign: "center",
    align: "center",
    renderCell: (params) => {
      return (
        <span>
          {params?.row?.favorites_count || params?.row?.number_of_favorites}
        </span>
      );
    },
  },

  {
    field: "share_count",
    headerName: "عدد مرات المشاركة",
    minWidth: 160, // Increased from 30 to be more readable
    headerAlign: "center",
    align: "center",
  },

  {
    field: "app_percentage",
    headerName: "نسبة التطبيق",
    minWidth: 160, // Increased from 30 to be more readable
    headerAlign: "center",
    align: "center",
  },
];

export const FactoriesColumns = [
  {
    field: "index",
    headerName: "#",
    minWidth: 40,
    headerAlign: "center",
    align: "center",
  },

  {
    field: "logo",
    headerName: "الشعار",
    minWidth: 80,
    headerAlign: "center",
    align: "center",

    renderCell: (params) => {
      return (
        <div className="cell-img">
          <img src={params?.row?.logo} alt="" />
        </div>
      );
    },
  },

  {
    field: "name",
    headerName: "اسم المصنع",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
  },

  {
    field: "phone",
    headerName: "رقم الموبايل",
    minWidth: 160, // Increased from 30 to be more readable
    headerAlign: "center",
    align: "center",
  },

  {
    field: "email",
    headerName: "الايميل",
    minWidth: 160, // Increased from 30 to be more readable
    headerAlign: "center",
    align: "center",
  },

  {
    field: "country",
    headerName: "البلد",
    minWidth: 160, // Increased from 30 to be more readable
    headerAlign: "center",
    align: "center",
  },

  {
    field: "governorate",
    headerName: "المحافظة",
    minWidth: 160, // Increased from 30 to be more readable
    headerAlign: "center",
    align: "center",
  },

  {
    field: "city",
    headerName: "المنطقة",
    minWidth: 160, // Increased from 30 to be more readable
    headerAlign: "center",
    align: "center",
  },

  {
    field: "rating",
    headerName: "التقييم الاجمالي",
    minWidth: 160, // Increased from 30 to be more readable
    headerAlign: "center",
    align: "center",
  },

  {
    field: "working_scope",
    headerName: "نطاق العمل",
    minWidth: 160, // Increased from 30 to be more readable
    headerAlign: "center",
    align: "center",
  },

  {
    field: "register_type",
    headerName: "طريقة التسجيل",
    minWidth: 160, // Increased from 30 to be more readable
    headerAlign: "center",
    align: "center",
  },

  {
    field: "created_at",
    headerName: "تاريخ و وقت التسجيل",
    minWidth: 160, // Increased from 30 to be more readable
    headerAlign: "center",
    align: "center",

    renderCell: (params) =>
      moment(params?.row?.created_at).format("YYYY-MM-DD"),
  },

  {
    field: "number_of_orders",
    headerName: "عدد الطلبات",
    minWidth: 160, // Increased from 30 to be more readable
    headerAlign: "center",
    align: "center",
  },

  {
    field: "number_of_products",
    headerName: "عدد المنتجات",
    minWidth: 160, // Increased from 30 to be more readable
    headerAlign: "center",
    align: "center",
  },

  {
    field: "favorites_count",
    headerName: "عدد مرات الاضافة للمفضلة",
    minWidth: 240, // Increased from 30 to be more readable
    headerAlign: "center",
    align: "center",
    renderCell: (params) => {
      return (
        <span>
          {params?.row?.favorites_count || params?.row?.number_of_favorites}
        </span>
      );
    },
  },

  {
    field: "share_count",
    headerName: "عدد مرات المشاركة",
    minWidth: 160, // Increased from 30 to be more readable
    headerAlign: "center",
    align: "center",
  },
  {
    field: "app_percentage",
    headerName: "نسبة التطبيق",
    minWidth: 160, // Increased from 30 to be more readable
    headerAlign: "center",
    align: "center",
  },

  {
    field: "allow_negotiation",
    headerName: "اتاحة التفاوض",
    minWidth: 160, // Increased from 30 to be more readable
    headerAlign: "center",
    align: "center",

    renderCell: (params) => (
      <span>{params?.row?.allow_negotiation === 1 ? "نعم" : "لا"}</span>
    ),
  },

  {
    field: "availability_samples",
    headerName: "اتاحة العينات",
    minWidth: 160, // Increased from 30 to be more readable
    headerAlign: "center",
    align: "center",

    renderCell: (params) => (
      <span>{params?.row?.availability_samples === 1 ? "نعم" : "لا"}</span>
    ),
  },
];

export const CouponsColumns = [
  {
    field: "index",
    headerName: "#",
    minWidth: 40,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "code",
    headerName: "كود الخصم",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "type",
    headerName: "نوع الكود",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => {
      return (
        <span>
          {params?.row?.type === "percent" ? "نسبة مئوية" : "مبلغ ثابت"}
        </span>
      );
    },
  },
  {
    field: "discount_amount",
    headerName: "الخصم",
    minWidth: 220,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "max_discount",
    headerName: "الحد الاقصي للخصم",
    minWidth: 220,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "max_uses",
    headerName: "عدد مرات الاستخدام",
    minWidth: 220,
    headerAlign: "center",
    align: "center",
  },

  {
    field: "max_uses_user",
    headerName: "عدد من استخدمه",
    minWidth: 220,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "created_at",
    headerName: "تاريخ الانشاء",
    minWidth: 220,
    headerAlign: "center",
    align: "center",
    renderCell: (params) =>
      moment(params?.row?.created_at).format("YYYY-MM-DD"),
  },
  {
    field: "start_date",
    headerName: "تاريخ البداية",
    minWidth: 220,
    headerAlign: "center",
    align: "center",
    renderCell: (params) =>
      moment(params?.row?.start_date).format("YYYY-MM-DD"),
  },
  {
    field: "end_date",
    headerName: "تاريخ الانتهاء",
    minWidth: 220,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => moment(params?.row?.end_date).format("YYYY-MM-DD"),
  },
];

export const UserAddressColumns = [
  {
    field: "index",
    headerName: "#",
    minWidth: 20,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "address",
    headerName: "العنوان",
    minWidth: 70,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "phone",
    headerName: "رقم الموبايل",
    minWidth: 110,
    headerAlign: "center",
    align: "center",
    flex: 1,
  },
  //ناقصه
  {
    field: "country",
    headerName: "البلد",
    minWidth: 40,
    headerAlign: "center",
    align: "center",
    flex: 1,
  },
  //ناقصه
  {
    field: "governorate",
    headerName: "المحافظة",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
    flex: 1,
  },
  //ناقصه
  {
    field: "city",
    headerName: "المدينة",
    minWidth: 120,
    headerAlign: "center",
    align: "center",
    flex: 1,
  },
  {
    field: "building_no",
    headerName: "رقم المنزل",
    minWidth: 40,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "floor_no",
    headerName: "رقم الدور",
    minWidth: 40,
    headerAlign: "center",
    align: "center",
  },
  //ناقصه
  {
    field: "created_at",
    headerName: "تاريخ و وقت الانشاء",
    minWidth: 240,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => (
      <span>
        {params?.row?.created_at
          ? moment(params?.row?.created_at).format("DD/MM/YYYY HH:mm:ss")
          : "-"}
      </span>
    ),
  },
];
export const IntroductionPagesColumns = [
  {
    field: "index",
    headerName: "#",
    minWidth: 20,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "image",
    headerName: "الصورة",
    minWidth: 60,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => {
      return (
        <div className="cell-img">
          <img src={params?.row?.image} alt="" />
        </div>
      );
    },
  },
  {
    field: "title_ar",
    headerName: "عنوان النص",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "country",
    headerName: "اسم البلد",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
  },
];

export const CountriesColumns = [
  {
    field: "index",
    headerName: "#",
    minWidth: 20,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "ar.name",
    headerName: "اسم البلد بالعربية",
    minWidth: 220,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "en.name",
    headerName: "اسم البلد بالانجليزية",
    minWidth: 220,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "ar.currency",
    headerName: "العملة بالعربية",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "en.currency",
    headerName: "العملة بالانجليزية",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
  },
  //ناقصه
  {
    field: "currency",
    headerName: "القيمة المضافة",
    minWidth: 120,
    headerAlign: "center",
    align: "center",
  },
];

export const UserRatesColumns = [
  {
    field: "index",
    headerName: "#",
    minWidth: 40,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "product_images",
    headerName: "الصورة",
    minWidth: 60,
    headerAlign: "center",
    align: "center",

    renderCell: (params) => {
      return (
        <div className="cell-img">
          <img src={params?.row?.product_images[0].image_path} alt="" />
        </div>
      );
    },
  },
  {
    field: "product",
    headerName: "اسم المنتج",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
    flex: 1,
  },
  {
    field: "rating",
    headerName: "تقييم المنتج",
    minWidth: 160,
    headerAlign: "center",
    align: "center",

    flex: 1,
    renderCell: (params) => {
      return (
        <Rating
          name="text-feedback"
          value={params?.row?.rating}
          readOnly
          precision={0.5}
          emptyIcon={<StarIcon style={{ opacity: 0.55 }} fontSize="10px" />}
        />
      );
    },
  },
  {
    field: "vendor",
    headerName: "اسم المتجر",
    minWidth: 160,
    headerAlign: "center",
    align: "center",

    flex: 1,
  },
  {
    field: "vendor_rating",
    headerName: "تقييم المتجر",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
    flex: 1,
    renderCell: (params) => {
      return (
        <Rating
          name="text-feedback"
          value={params?.row?.vendor_rating}
          readOnly
          precision={0.5}
          emptyIcon={<StarIcon style={{ opacity: 0.55 }} fontSize="10px" />}
        />
      );
    },
  },
];

export const QuestionColumns = [
  {
    field: "index",
    headerName: "#",
    minWidth: 40,
    headerAlign: "center",
    align: "center",
  },

  {
    field: "question_ar",
    headerName: "السؤال",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "chats_count",
    headerName: "عدد رسائل الدعم المتعلقة بالسؤال",
    minWidth: 240,
    headerAlign: "center",
    align: "center",
  },

  {
    field: "created_at",
    headerName: "تاريخ و وقت الانشاء",
    minWidth: 240,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => (
      <span>
        {params?.row?.created_at
          ? moment(params?.row?.created_at).format("DD/MM/YYYY HH:mm:ss")
          : "-"}
      </span>
    ),
  },
];

export const ChatColumns = [
  {
    field: "index",
    headerName: "#",
    minWidth: 40,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "id",
    headerName: "رقم الدعم",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "support_question",
    headerName: "السؤال",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "user_name",
    headerName: "اسم المستخدم",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "user_phone",
    headerName: "رقم موبايل",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "created_at",
    headerName: "تاريخ و وقت الطلب",
    minWidth: 240,
    headerAlign: "center",
    align: "center",
    flex: 1,
    renderCell: (params) => (
      <span>
        {params?.row?.created_at
          ? moment(params?.row?.created_at).format("DD/MM/YYYY HH:mm:ss")
          : "-"}
      </span>
    ),
  },
  {
    field: "status",
    headerName: "حالة الدعم",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
    flex: 1,
    renderCell: (params) => {
      const isWorking = params?.row?.finish === 0;

      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
          }}
        >
          <span
            className={`status-badge ${
              isWorking ? "status-badge--working" : "status-badge--finished"
            }`}
          >
            <span className="status-icon">{isWorking ? "⏳" : "✅"}</span>
            {isWorking ? "جاري العمل" : "تم الانتهاء"}
          </span>
        </div>
      );
    },
  },
];

export const CountryColumns = [
  {
    field: "index",
    headerName: "#",
    width: 40,
    headerAlign: "center",
    align: "center",
  },

  {
    field: "name_ar",
    headerName: "اسم البلد بالعربية",
    minWidth: 160,
    flex: 1,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "name_en",
    headerName: "اسم البلد بالانجليزية",
    minWidth: 160,
    flex: 1,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "currency_ar",
    headerName: "العملة بالعربية",
    minWidth: 160,
    flex: 1,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "currency_en",
    headerName: "العملة بالانجليزية",
    minWidth: 160,
    flex: 1,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "value_added",
    headerName: "القيمة المضافة",
    minWidth: 160,
    flex: 1,
    headerAlign: "center",
    align: "center",
  },
];

export const GovernorateColumns = [
  {
    field: "index",
    headerName: "#",
    width: 40,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "name_ar",
    headerName: "اسم المحافظة بالعربية",
    minWidth: 160,
    flex: 1,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "name_en",
    headerName: "اسم المحافظة بالانجليزية",
    minWidth: 160,
    flex: 1,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "country",
    headerName: "البلد",
    minWidth: 160,
    flex: 1,
    headerAlign: "center",
    align: "center",
  },
];

export const RegionColumns = [
  {
    field: "index",
    headerName: "#",
    width: 40,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "name_ar",
    headerName: "اسم المنطقة بالعربية",
    minWidth: 160,
    flex: 1,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "name_en",
    headerName: "اسم المنطقة بالانجليزية",
    minWidth: 160,
    flex: 1,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "governorate",
    headerName: "المحافظة",
    minWidth: 160,
    flex: 1,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "country",
    headerName: "البلد",
    minWidth: 160,
    flex: 1,
    headerAlign: "center",
    align: "center",
  },
];

export const ShippingColumns = [
  {
    field: "index",
    headerName: "#",
    width: 40,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "name_ar",
    headerName: "اسم المحافظة بالعربية",
    minWidth: 160,
    flex: 1,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "name_en",
    headerName: "اسم المحافظة بالانجليزية",
    minWidth: 160,
    flex: 1,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "delivery",
    headerName: "سعر الشحن",
    minWidth: 120,
    flex: 1,
    headerAlign: "center",
    align: "center",
  },
];

export const AdminsColumns = [
  {
    field: "index",
    headerName: "#",
    minWidth: 20,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "image",
    headerName: "الصورة",
    minWidth: 80,
    headerAlign: "center",
    align: "center",

    renderCell: (params) => {
      return (
        <div className="cell-img">
          <img src={params?.row?.image} alt="" />
        </div>
      );
    },
  },
  {
    field: "name",
    headerName: "الاسم",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "phone",
    headerName: "رقم الموبايل",
    minWidth: 160,
    flex: 1,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "email",
    headerName: "البريد الالكتروني",
    minWidth: 160,
    flex: 1,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "created_at",
    headerName: "تاريخ و وقت الانشاء",
    minWidth: 160,
    flex: 1,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => {
      // Fix the date format by removing the "pm" or "am" suffix
      const dateString = params?.row?.created_at?.replace(/ (am|pm)$/i, "");
      return <span>{moment(dateString).format("DD/MM/YYYY hh:mm a")}</span>;
    },
  },
  {
    field: "role",
    headerName: "الصلاحية",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
  },

  {
    field: "last_login",
    headerName: "اخر تسجيل دخول",
    minWidth: 160,
    flex: 1,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => {
      // Fix the date format by removing the "pm" or "am" suffix
      const dateString = params?.row?.last_login?.replace(/ (am|pm)$/i, "");
      return <span>{moment(dateString).format("DD/MM/YYYY hh:mm a")}</span>;
    },
  },
];

export const AdminsPermissionsColumns = [
  {
    field: "index",
    headerName: "#",
    minWidth: 20,
    headerAlign: "center",
    align: "center",
  },

  {
    field: "name",
    headerName: "الاسم",
    minWidth: 84,
    headerAlign: "center",
    align: "center",
  },

  {
    field: "users_count",
    headerName: "عدد المسؤولين",
    minWidth: 110,
    headerAlign: "center",
    align: "center",
  },
];

export const ViewProductsColumns = [
  {
    field: "department",
    headerName: "القسم الرئيسي",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => params?.row?.category?.main_category,
  },
  {
    field: "sub_department_one",
    headerName: "القسم الفرعي -1",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => params?.row?.category?.sub_category,
  },
  {
    field: "sub_department_two",
    headerName: "القسم الفرعي -2",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => params?.row?.category?.sub_sub_category,
  },

  {
    field: "discount",
    headerName: "الخصم",
    minWidth: 100,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => {
      return <div className="cell-img">{params?.row?.discount} %</div>;
    },
  },

  {
    field: "discount_date_to",
    headerName: "تاريخ انتهاء الخصم",
    minWidth: 240,
    flex: 1,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => (
      <span>
        {params?.row?.discount_date_to
          ? moment(params?.row?.discount_date_to).format(
              "DD/MM/YYYY hh:mm:ss a",
            )
          : "-"}
      </span>
    ),
  },
  {
    field: "created_at",
    headerName: "تاريخ و وقت الاضافة",
    minWidth: 240,
    flex: 1,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => (
      <span>
        {params?.row?.created_at
          ? moment(params?.row?.created_at).format("DD/MM/YYYY hh:mm:ss a")
          : "-"}
      </span>
    ),
  },

  {
    field: "country",
    headerName: "تطاق العمل",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
  },
  // {
  //   field: "appearance_count",
  //   headerName: "مدة الظهور",
  //   minWidth: 160,
  //   headerAlign: "center",
  //   align: "center",
  // },
  // {
  //   field: "time_remaining",
  //   headerName: "المدة المتبقية للظهور",
  //   minWidth: 160,
  //   headerAlign: "center",
  //   align: "center",
  // },
];

export const ViewProductsFeaturesColumns = [
  {
    field: "index",
    headerName: "#",
    minWidth: 4,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "department",
    headerName: "نوع السمة",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => {
      const typeMap = {
        color: "لون",
        size: "مقاس",
        unit: "حجم",
        color_size: "لون ومقاس",
        color_unit: "لون وحجم",
        unit_size: "مقاس وحجم",
      };
      return typeMap[params?.row?.type] || params?.row?.type;
    },
  },
  {
    field: "sub_department_one",
    headerName: "لون",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => {
      // Check if type includes color and color object exists
      if (params?.row?.type?.includes("color") && params?.row?.color?.name) {
        const colorName =
          params?.row?.color?.name?.ar ||
          params?.row?.color?.name?.en ||
          params?.row?.color?.name;
        const colorCode = params?.row?.color?.color;

        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              justifyContent: "center",
            }}
          >
            {colorCode && (
              <div
                style={{
                  width: "20px",
                  height: "20px",
                  backgroundColor: colorCode,
                  borderRadius: "50%",
                  border: "1px solid #ccc",
                }}
              />
            )}
            <span>{colorName}</span>
          </div>
        );
      }
      return "غير محدد";
    },
  },
  {
    field: "sub_department_two",
    headerName: "مقاس",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => {
      // Check if type includes size and size object exists
      if (params?.row?.type?.includes("size") && params?.row?.size?.name) {
        const sizeName =
          params?.row?.size?.name?.ar ||
          params?.row?.size?.name?.en ||
          params?.row?.size?.name;
        return sizeName;
      }
      return "غير محدد";
    },
  },
  {
    field: "sub_department_three", // Added new column for unit
    headerName: "حجم",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => {
      // Check if type includes unit and unit object exists
      if (params?.row?.type?.includes("unit") && params?.row?.unit?.name) {
        const unitName =
          params?.row?.unit?.name?.ar ||
          params?.row?.unit?.name?.en ||
          params?.row?.unit?.name;
        return unitName;
      }
      return "غير محدد";
    },
  },
  {
    field: "qty",
    headerName: "كمية",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => params?.row?.qty || 0,
  },
  {
    field: "rate10",
    headerName: "الخصم",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => {
      const percentageDiscount = params?.row?.percentage_discount || 0;
      const fixedDiscount = params?.row?.fixed_discount || 0;
      return `${percentageDiscount}% (${fixedDiscount} جنية)`;
    },
  },
  {
    field: "rate1",
    headerName: "تاريخ انتهاء الخصم",
    minWidth: 240,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => (
      <span>
        {params?.row?.discount_date_to
          ? moment(params?.row?.discount_date_to).format(
              "DD/MM/YYYY hh:mm:ss a",
            )
          : "-"}
      </span>
    ),
  },
];

export const ViewProductsRangesPriceColumns = [
  {
    field: "min_qty",
    headerName: "نطاق الاسعار من",
    minWidth: 120,
    flex: 1,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "max_qty",
    headerName: "نطاق الاسعار الي",
    minWidth: 120,
    flex: 1,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "price",
    headerName: "السعر",
    minWidth: 100,
    headerAlign: "center",
    align: "center",
  },
];

export const ViewProductsRatesColumns = [
  {
    field: "index",
    headerName: "#",
    minWidth: 40,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "image",
    headerName: "الصورة",
    minWidth: 60,
    headerAlign: "center",
    align: "center",

    renderCell: (params) => {
      return (
        <div className="cell-img">
          <img src={params?.row?.user_id?.image} alt="" />
        </div>
      );
    },
  },
  {
    field: "name",
    headerName: "الاسم",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => {
      return <span>{params?.row?.user_id?.name || "-"}</span>;
    },
  },
  {
    field: "product_rate",
    headerName: "التقييم",
    minWidth: 160,
    headerAlign: "center",
    align: "center",

    renderCell: (params) => {
      return (
        <Rating
          name="text-feedback"
          value={params?.row?.rating || 0}
          readOnly
          precision={0.5}
          emptyIcon={<StarIcon style={{ opacity: 0.55 }} fontSize="10px" />}
        />
      );
    },
  },
];

export const ProductOrdersColumns = [
  {
    field: "index",
    headerName: "#",
    minWidth: 40,
    headerAlign: "center",
    align: "center",
  },

  {
    field: "order_number",
    headerName: "رقم الطلب",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
  },

  {
    field: "user.name",
    headerName: "اسم المستخدم",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => {
      return <span>{params?.row?.user?.name || "-"}</span>;
    },
  },

  {
    field: "user.phone",
    headerName: "رقم موبايل المستخدم",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => {
      return <span>{params?.row?.user?.phone || "-"}</span>;
    },
  },

  {
    field: "coupon",
    headerName: "كود الخصم",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => {
      return <span>{params?.row?.coupon || "لا يوجد"}</span>;
    },
  },

  {
    field: "discount",
    headerName: "قيمة الخصم",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => {
      return <span>{params?.row?.discount || "لا يوجد"}</span>;
    },
  },

  {
    field: "total",
    headerName: "المبلغ الاجمالي للفاتورة",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
  },

  {
    field: "created_at",
    headerName: "تاريخ و وقت الطلب",
    minWidth: 220,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => (
      <span>
        {params?.row?.created_at
          ? moment(params?.row?.created_at).format("DD/MM/YYYY hh:mm:ss a")
          : "-"}
      </span>
    ),
  },

  {
    field: "products_num",
    headerName: "عدد المنتجات",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
  },

  {
    field: "vendors_num",
    headerName: "عدد المتاجر داخل الطلب",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
  },

  {
    field: "payment_type",
    headerName: "طريقة الدفع",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
  },
];

export const OrderColumns = [
  {
    field: "index",
    headerName: "#",
    minWidth: 40,
    headerAlign: "center",
    align: "center",
  },

  {
    field: "image",
    headerName: "الصورة",
    minWidth: 60,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => {
      const variation = params?.row?.variations;
      const variationImage =
        variation?.variations_images?.length > 0
          ? variation.variations_images[0].image_path
          : null;
      const imgSrc = variationImage || params?.row?.image;
      return (
        <div className="cell-img">
          <img src={imgSrc} alt="" />
        </div>
      );
    },
  },

  {
    field: "name",
    headerName: "اسم المنتج",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
  },

  {
    field: "category",
    headerName: "القسم الرئيسي",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => {
      return (
        <span>
          {params?.row?.category?.main_category || params?.row?.category?.title}
        </span>
      );
    },
  },
  {
    field: "sub_department_one",
    headerName: "القسم الفرعي -1",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => {
      return <span>{params?.row?.category?.sub_category || "-"}</span>;
    },
  },
  {
    field: "sub_department_two",
    headerName: "القسم الفرعي -2",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => {
      return <span>{params?.row?.category?.sub_sub_category || "-"}</span>;
    },
  },

  {
    field: "qty",
    headerName: "الكمية",
    minWidth: 100,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => {
      return <span>{params?.row?.qty || "لا يوجد"}</span>;
    },
  },

  {
    field: "size",
    headerName: "الحجم",
    minWidth: 100,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => {
      const variation = params?.row?.variations;
      const variationSize = variation?.size;
      const sizeValue =
        variationSize && Object.keys(variationSize).length > 0
          ? variationSize?.name?.ar ||
            variationSize?.name?.en ||
            variationSize?.name
          : params?.row?.size;
      return <span>{sizeValue || "لا يوجد"}</span>;
    },
  },

  {
    field: "unit",
    headerName: "الوحدة",
    minWidth: 100,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => {
      const variation = params?.row?.variations;
      const variationUnit = variation?.unit;
      const unitValue =
        variationUnit && Object.keys(variationUnit).length > 0
          ? variationUnit?.name?.ar ||
            variationUnit?.name?.en ||
            variationUnit?.name
          : params?.row?.unit;
      return <span>{unitValue || "لا يوجد"}</span>;
    },
  },

  {
    field: "colors",
    headerName: "اللون",
    minWidth: 120,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => {
      const variation = params?.row?.variations;
      const variationColor =
        variation?.color && Object.keys(variation.color).length > 0
          ? variation.color
          : null;
      const color = variationColor || params?.row?.colors;
      if (!color || !color.name) {
        return <span>لا يوجد</span>;
      }
      return (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              width: "20px",
              height: "20px",
              backgroundColor: color.color || "#000",
              border: "1px solid #ccc",
              borderRadius: "4px",
            }}
          />
          <span>{color.name?.ar || color.name?.en || "لا يوجد"}</span>
        </div>
      );
    },
  },

  {
    field: "rating",
    headerName: "التقييم الاجمالي",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "price",
    headerName: "السعر الافتراضي",
    minWidth: 120,
    headerAlign: "center",
    align: "center",
  },
];

export const DepartmentColumns = [
  {
    field: "index",
    headerName: "#",
    minWidth: 40,
    headerAlign: "center",
    align: "center",
  },

  {
    field: "image",
    headerName: "الصورة",
    minWidth: 60,
    headerAlign: "center",
    align: "center",

    renderCell: (params) => {
      return (
        <div className="cell-img">
          <img src={params?.row?.image} alt="" />
        </div>
      );
    },
  },

  {
    field: "title_ar",
    headerName: "القسم الرئيسي",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
  },
  // {
  //   field: "title_en",
  //   headerName: "الاسم بالانجليزية",
  //   minWidth: 160,
  //   headerAlign: "center",
  //   align: "center",

  // },

  {
    field: "sub_categories",
    headerName: "عدد الاقسام الفرعية المندرجة",
    minWidth: 220,
    headerAlign: "center",
    align: "center",

    renderCell: (params) => {
      return <span>{params?.row?.sub_categories?.length}</span>;
    },
  },
];

export const SubDepartmentColumns = [
  {
    field: "index",
    headerName: "#",
    minWidth: 40,
    headerAlign: "center",
    align: "center",
  },

  {
    field: "image",
    headerName: "الصورة",
    minWidth: 60,
    headerAlign: "center",
    align: "center",

    renderCell: (params) => {
      return (
        <div className="cell-img">
          <img src={params?.row?.image} alt="" />
        </div>
      );
    },
  },

  {
    field: "title_ar",
    headerName: "الاسم",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
    flex: 1,
  },

  {
    field: "main_category",
    headerName: "القسم الرئيسي",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
  },

  {
    field: "products_count",
    headerName: "عدد المنتجات",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
    flex: 1,
  },
];

export const AdminsPermissionsData = [
  {
    id: "1",
    name: "مدير",
    count: "17",
    status: true,
  },
  {
    id: "2",
    name: "غفير",
    count: "27",
    status: true,
  },
  {
    id: "3",
    name: "امير",
    count: "1",
    status: true,
  },
  {
    id: "4",
    name: "عويل",
    count: "7",
    status: true,
  },
];

export const AdminsData = [
  {
    id: "1",
    name: "eyad adel",
    phone: "+201028252809",
    email: "username1@mail.com",
    date: "22/03/2024- 08:30 PM",
    permission: "مدير",
    last_login: "22/03/2024- 08:30 PM",
    method: "رقم هاتف",
    orders: "20",
    status: true,
  },
  {
    id: "2",
    name: "eyad adel",
    phone: "+201028252807",
    email: "username2@mail.com",
    date: "22/03/2024- 08:30 PM",
    permission: "سكرتير",
    last_login: "22/03/2024- 08:30 PM",
    method: "فيس بوك",
    orders: "17",
    status: true,
  },
  {
    id: "3",
    name: "eyad adel",
    phone: "+201028252808",
    email: "username3@mail.com",
    date: "22/03/2024- 08:30 PM",
    permission: "عامل",
    last_login: "22/03/2024- 08:30 PM",
    method: "تويتر",
    orders: "15",
    status: false,
  },
  {
    id: "4",
    name: "eyad adel",
    phone: "+201028252806",
    email: "username4@mail.com",
    date: "22/03/2024- 08:30 PM",
    permission: "مندوب",
    last_login: "22/03/2024- 08:30 PM",
    method: "رقم هاتف",
    orders: "3",
    status: true,
  },
  {
    id: "5",
    name: "eyad adel",
    phone: "+201028252805",
    email: "username5@mail.com",
    date: "22/03/2024- 08:30 PM",
    permission: "مبرمج",
    last_login: "22/03/2024- 08:30 PM",
    method: "ايميل",
    orders: "0",
    status: false,
  },
];

export const AdminPermissions = [
  {
    flex: "3",
    id: 1,
    name: "لوحة التحكم",
    sub_permissions: [
      {
        id: 1,
        name: "رؤية لوحة التحكم",
      },
      {
        id: 3,
        name: "عدد المستخدمين",
      },
      {
        id: 4,
        name: "عدد المتاجر",
      },
      {
        id: 5,
        name: "عدد منتجات المتاجر",
      },
      {
        id: 6,
        name: "عدد المصانع",
      },
      {
        id: 7,
        name: "عدد منتجات المصانع",
      },
      {
        id: 8,
        name: "عدد الطلبات الحالية",
      },
      {
        id: 9,
        name: "عدد المنتجات المنتهية",
      },
      {
        id: 10,
        name: "عدد الطلبات المنتهية",
      },
      {
        id: 11,
        name: "عدد الطلبات الملغية",
      },
      {
        id: 13,
        name: "المستخدمين المنضمين حديثا",
      },
    ],
  },
  {
    id: 14,
    name: "المسؤلين الفرعين",
    sub_permissions: [
      {
        id: 14,
        name: "رؤية المسؤلين الفرعين",
      },
      {
        id: 15,
        name: "تفعيل",
      },
      {
        id: 16,
        name: "اضافة",
      },
      {
        id: 17,
        name: "تعديل",
      },
      {
        id: 18,
        name: "حذف",
      },
      {
        id: 198,
        name: "رؤية",
      },
    ],
  },
  {
    id: 19,
    name: "الصلاحيات",
    sub_permissions: [
      {
        id: 19,
        name: "رؤية الصلاحيات",
      },
      {
        id: 20,
        name: "تفعيل",
      },
      {
        id: 21,
        name: "تعديل",
      },
      {
        id: 183,
        name: "اضافة",
      },
      {
        id: 184,
        name: "حذف",
      },
      // {
      //   id: 185,
      //   name: "رؤية",
      // },
    ],
  },
  {
    id: 22,
    flex: "2",
    name: "المستخدمين",
    sub_permissions: [
      {
        id: 22,
        name: "رؤية المستخدمين",
      },
      {
        id: 23,
        name: "تفعيل",
      },
      // {
      //   id: 24,
      //   name: "اضافة",
      // },
      {
        id: 25,
        name: "تعديل",
      },
      {
        id: 26,
        name: "حذف",
      },
      {
        id: 27,
        name: "رؤية",
      },
      {
        id: 28,
        name: "تغير كلمة السر",
      },
    ],
  },
  {
    flex: "2",
    id: 29,
    name: "المتاجر",
    sub_permissions: [
      {
        id: 29,
        name: "رؤية المتاجر",
      },
      {
        id: 30,
        name: "تفعيل",
      },
      {
        id: 31,
        name: "اضافة",
      },
      {
        id: 32,
        name: "تعديل",
      },
      {
        id: 33,
        name: "حذف",
      },
      {
        id: 34,
        name: "رؤية",
      },
      {
        id: 35,
        name: "تغير كلمة السر",
      },
    ],
  },

  {
    id: 39,
    flex: "1",
    name: "طلبات التعديل على اوراق المتاجر / المصانع",
    sub_permissions: [
      {
        id: 39,
        name: "رؤية طلبات التعديل علي الاوراق",
      },
      {
        id: 40,
        name: "رؤية",
      },
      {
        id: 41,
        name: "الموافقة على الطلب",
      },
    ],
  },

  {
    id: 199,
    flex: "1",
    name: "طلبات اضافة و تعديل المنتجات",
    sub_permissions: [
      {
        id: 199,
        name: "رؤية طلبات اضافة و تعديل المنتجات",
      },
      {
        id: 200,
        name: "رؤية",
      },
      {
        id: 201,
        name: "الموافقة على الطلب",
      },
    ],
  },
  {
    id: 42,
    name: "طلبات تسجيل المتاجر / المصانع",
    sub_permissions: [
      {
        id: 42,
        name: "رؤية طلبات تسجيل المتاجر / المصانع",
      },
      {
        id: 43,
        name: "رؤية",
      },
      {
        id: 44,
        name: "الموافقة على الطلب",
      },
    ],
  },
  {
    id: 49,
    name: "اكواد الخصم",
    sub_permissions: [
      {
        id: 49,
        name: "رؤية اكواد الخصم",
      },
      {
        id: 50,
        name: "تفعيل",
      },
      {
        id: 51,
        name: "اضافة",
      },
      {
        id: 52,
        name: "تعديل",
      },
      {
        id: 53,
        name: "حذف",
      },
      {
        id: 54,
        name: "رؤية",
      },
    ],
  },
  {
    id: 68,
    name: "الطلبات على المنتجات",
    sub_permissions: [
      {
        id: 68,
        name: "رؤية الطلبات علي المنتجات",
      },
      {
        id: 69,
        name: "الغاء الطلب",
      },
      {
        id: 140,
        name: "حذف",
      },
      {
        id: 141,
        name: "رؤية",
      },
    ],
  },
  {
    flex: "2",
    id: 78,
    name: "المنتجات",
    sub_permissions: [
      {
        id: 78,
        name: "رؤية المنتجات",
      },
      {
        id: 79,
        name: "تفعيل",
      },
      {
        id: 80,
        name: "اضافة",
      },
      {
        id: 81,
        name: "تعديل",
      },
      {
        id: 82,
        name: "حذف",
      },
      {
        id: 83,
        name: "رؤية",
      },
      {
        id: 84,
        name: "اضافة خصم",
      },
      {
        id: 86,
        name: "تصدير شيت اكسل",
      },
      {
        id: 87,
        name: "ارفاق شيت اكسل",
      },
    ],
  },
  {
    id: 88,
    name: "سمات المنتجات",
    sub_permissions: [
      {
        id: 88,
        name: "رؤية سمات المنتجات",
      },
      {
        id: 89,
        name: "تفعيل",
      },
      {
        id: 90,
        name: "تعديل",
      },
      {
        id: 91,
        name: "رؤية",
      },
      {
        id: 186,
        name: "اضافة",
      },
      {
        id: 191,
        name: "حذف",
      },
    ],
  },
  {
    id: 92,
    name: "الأقسام",
    sub_permissions: [
      {
        id: 92,
        name: "رؤية الاقسام",
      },
      {
        id: 93,
        name: "تفعيل",
      },
      {
        id: 94,
        name: "اضافة",
      },
      {
        id: 137,
        name: "تعديل",
      },
      {
        id: 138,
        name: "حذف",
      },
      {
        id: 139,
        name: "رؤية",
      },
    ],
  },
  {
    id: 129,
    name: "المصانع",
    sub_permissions: [
      {
        id: 129,
        name: "رؤية المصانع",
      },
      {
        id: 130,
        name: "تفعيل",
      },
      {
        id: 131,
        name: "اضافة",
      },
      {
        id: 132,
        name: "تعديل",
      },
      {
        id: 133,
        name: "حذف",
      },
      {
        id: 134,
        name: "رؤية",
      },
      {
        id: 135,
        name: "تغير كلمة السر",
      },
    ],
  },
  {
    id: 110,
    name: "الصور الإعلانية للموقع",
    sub_permissions: [
      {
        id: 110,
        name: "رؤية الصور الاعلانية للموقع",
      },
      {
        id: 120,
        name: "اضافة",
      },
      {
        id: 122,
        name: "حذف",
      },
    ],
  },
  {
    id: 114,
    name: "الإشعارات",
    sub_permissions: [
      {
        id: 114,
        name: "رؤية الاشعارات",
      },
      {
        id: 187,
        name: "اضافة",
      },
      {
        id: 188,
        name: "تعديل",
      },
      {
        id: 189,
        name: "حذف",
      },
      {
        id: 190,
        name: "روية",
      },
    ],
  },
  {
    id: 118,
    name: "اسئلة الدعم الفنى",
    sub_permissions: [
      {
        id: 118,
        name: "رؤية اسئلة الدعم الفني",
      },
      {
        id: 124,
        name: "تفعيل",
      },
      {
        id: 125,
        name: "اضافة",
      },
      {
        id: 126,
        name: "تعديل",
      },
      {
        id: 127,
        name: "حذف",
      },
      {
        id: 192,
        name: "تفعيل",
      },
    ],
  },
  {
    id: 123,
    name: "رسائل الدعم الفنى",
    sub_permissions: [
      {
        id: 123,
        name: "رؤية رسائل الدعم الفني",
      },
      {
        id: 193,
        name: "تفعيل",
      },
      {
        id: 194,
        name: "اضافة",
      },
      {
        id: 195,
        name: "تعديل",
      },
      {
        id: 196,
        name: "حذف",
      },
    ],
  },
  {
    id: 142,
    name: "اعدادات عامة",
    sub_permissions: [
      {
        id: 142,
        name: "رؤية الاعدادات العامة",
      },
      {
        id: 143,
        name: "اعدادات ظهور المنتجات",
      },
    ],
  },
  {
    id: 144,
    name: "البلاد",
    sub_permissions: [
      {
        id: 144,
        name: "رؤية البلاد",
      },
      {
        id: 145,
        name: "اضافة بنك",
      },
      {
        id: 146,
        name: "اضافة",
      },
      {
        id: 147,
        name: "تعديل",
      },
      {
        id: 148,
        name: "حذف",
      },
    ],
  },
  {
    id: 149,
    name: "المحافظات",
    sub_permissions: [
      {
        id: 149,
        name: "رؤية المحافظات",
      },
      {
        id: 151,
        name: "اضافة",
      },
      {
        id: 152,
        name: "تعديل",
      },
      {
        id: 153,
        name: "حذف",
      },
    ],
  },
  {
    id: 150,
    name: "المناطق",
    sub_permissions: [
      { id: 150, name: "رؤية المناطق" },
      {
        id: 154,
        name: "اضافة",
      },
      {
        id: 155,
        name: "تعديل",
      },
      {
        id: 156,
        name: "حذف",
      },
    ],
  },
  {
    id: 157,
    name: "شروط واحكام التطبيق",
    sub_permissions: [
      { id: 157, name: "رؤية شروط واحكام التطبيق" },
      {
        id: 158,
        name: "اضافة",
      },
      {
        id: 159,
        name: "تعديل",
      },
      {
        id: 160,
        name: "حذف",
      },
      {
        id: 161,
        name: "روية",
      },
    ],
  },
  {
    id: 162,
    name: "شروط واحكام الموقع",
    sub_permissions: [
      { id: 162, name: "رؤية شروط واحكام الموقع" },
      {
        id: 163,
        name: "اضافة",
      },
      {
        id: 164,
        name: "تعديل",
      },
      {
        id: 165,
        name: "حذف",
      },
      {
        id: 166,
        name: "روية",
      },
    ],
  },
  {
    id: 167,
    name: "روابط تواصل معنا",
    sub_permissions: [
      { id: 167, name: "رؤية روابط تواصل معنا" },
      {
        id: 168,
        name: "تعديل",
      },
      {
        id: 169,
        name: "روية",
      },
    ],
  },
  {
    id: 170,
    name: "الصفحات التعريفية",
    sub_permissions: [
      { id: 170, name: "رؤية الصفحات التعريفية" },
      {
        id: 171,
        name: "اضافة",
      },
      {
        id: 172,
        name: "تعديل",
      },
      {
        id: 173,
        name: "حذف",
      },
      {
        id: 174,
        name: "روية",
      },
    ],
  },
  {
    id: 175,
    name: "صور سليدر الموقع",
    sub_permissions: [
      { id: 175, name: "رؤية صور سليدر الموقع" },
      {
        id: 176,
        name: "اضافة",
      },
      {
        id: 177,
        name: "حذف",
      },
    ],
  },
  {
    id: 178,
    name: "صور سليدر التطبيق",
    sub_permissions: [
      { id: 178, name: "رؤية صور سليدر التطبيق" },
      {
        id: 179,
        name: "اضافة",
      },
      {
        id: 180,
        name: "حذف",
      },
    ],
  },
  {
    id: 181,
    name: "روابط التطبيق",
    sub_permissions: [
      { id: 181, name: "رؤية روابط التطبيق" },
      {
        id: 182,
        name: "تعديل",
      },
    ],
  },
];

export const NotificationsColumns = [
  {
    field: "index",
    headerName: "#",
    minWidth: 40,
    headerAlign: "center",
    align: "center",
  },

  {
    field: "image",
    headerName: "الصورة",
    minWidth: 60,
    headerAlign: "center",
    align: "center",

    renderCell: (params) => {
      return (
        <div className="cell-img">
          <img src={params?.row?.image} alt="" />
        </div>
      );
    },
  },
  {
    field: "title_ar",
    headerName: "عنوان النص",
    minWidth: 320,
    headerAlign: "center",
    align: "center",
  },
];

export const ContactColumns = [
  {
    field: "index",
    headerName: "#",
    minWidth: 40,
    headerAlign: "center",
    align: "center",
  },

  {
    field: "fullname",
    headerName: "الاسم الكامل",
    minWidth: 200,
    headerAlign: "center",
    align: "center",
  },

  {
    field: "email",
    headerName: "البريد الالكتروني",
    minWidth: 240,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "phone",
    headerName: "رقم الموبايل",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "notices",
    headerName: "الاستفسار",
    minWidth: 320,
    flex: 1,
    headerAlign: "center",
    align: "center",
  },
];

export const CreateNotificationsColumns = [
  {
    field: "image",
    headerName: "الصورة",
    minWidth: 60,
    headerAlign: "center",
    align: "center",

    renderCell: (params) => {
      return (
        <div className="cell-img">
          <img src={AdminImg} alt="" />
        </div>
      );
    },
  },
  {
    field: "name",
    headerName: "الاسم",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "phone",
    headerName: "رقم الموبايل",
    minWidth: 110,
    flex: 1,
    headerAlign: "center",
    align: "center",
  },
];

export const DummyData = [
  {
    id: "1",
    name: "eyad adel",
    phone: "+201028252809",
    email: "username1@mail.com",
    date: "22/03/2024- 08:30 PM",
    method: "رقم هاتف",
    orders: "20",
    status: true,
  },
  {
    id: "2",
    name: "eyad adel",
    phone: "+201028252807",
    email: "username2@mail.com",
    date: "22/03/2024- 08:30 PM",
    method: "فيس بوك",
    orders: "17",
    status: true,
  },
  {
    id: "3",
    name: "eyad adel",
    phone: "+201028252808",
    email: "username3@mail.com",
    date: "22/03/2024- 08:30 PM",
    method: "تويتر",
    orders: "15",
    status: false,
  },
  {
    id: "4",
    name: "eyad adel",
    phone: "+201028252806",
    email: "username4@mail.com",
    date: "22/03/2024- 08:30 PM",
    method: "رقم هاتف",
    orders: "3",
    status: true,
  },
  {
    id: "5",
    name: "eyad adel",
    phone: "+201028252805",
    email: "username5@mail.com",
    date: "22/03/2024- 08:30 PM",
    method: "ايميل",
    orders: "0",
    status: false,
  },
];

const commonProps = {
  headerAlign: "center",
  align: "center",
  sortable: false,
};

export const ProductsColumns = [
  {
    ...commonProps,
    field: "index",
    headerName: "#",
    minWidth: 40,
  },
  {
    ...commonProps,
    field: "images",
    headerName: "الصورة",
    minWidth: 60,
    renderCell: (params) => {
      const imagePath = params?.row?.image;
      return (
        <div className="cell-img">
          <img src={imagePath} alt="" />
        </div>
      );
    },
  },
  {
    ...commonProps,
    field: "name",
    headerName: "اسم المنتج",
    minWidth: 160,
    renderCell: (params) => (
      <Tooltip content={params?.row?.name || "-"}>
        <span className="truncate max-w-xs">
          {params?.row?.name_ar || params?.row?.name || "-"}
        </span>
      </Tooltip>
    ),
  },
  {
    ...commonProps,
    field: "category",
    headerName: "القسم الرئيسي",
    minWidth: 160,
    renderCell: (params) => (
      <span className="truncate max-w-xs">
        {params?.row?.category?.main_category}
      </span>
    ),
  },
  {
    ...commonProps,
    field: "subCategory",
    headerName: "القسم الفرعي -1",
    minWidth: 160,
    renderCell: (params) => (
      <span>{params?.row?.category?.sub_category || "-"}</span>
    ),
  },
  {
    ...commonProps,
    field: "subCategory2",
    headerName: "القسم الفرعي -2",
    minWidth: 160,
    renderCell: (params) => (
      <span>{params?.row?.category?.sub_sub_category || "-"}</span>
    ),
  },
  {
    ...commonProps,
    field: "rating",
    headerName: "التقييم الاجمالي",
    minWidth: 160,
    renderCell: (params) => <span>{params?.row?.rating || "-"}</span>,
  },
  {
    ...commonProps,
    field: "price",
    headerName: "السعر الافتراضي",
    minWidth: 160,
    renderCell: (params) => (
      <span>{params?.row?.price ? `${params?.row?.price} جنية` : "-"}</span>
    ),
  },
  {
    ...commonProps,
    field: "stock",
    headerName: "الكمية المتاحة",
    minWidth: 160,
    renderCell: (params) => (
      <span
        className={`px-2 py-1 rounded ${
          params?.row?.stock <= 0
            ? "bg-red-100 text-red-800"
            : params?.row?.stock < 5
              ? "bg-yellow-100 text-yellow-800"
              : "bg-green-100 text-green-800"
        }`}
      >
        {params?.row?.stock || 0}
      </span>
    ),
  },
  // ناقصه
  {
    ...commonProps,
    field: "unit",
    headerName: "وحدة الكمية",
    minWidth: 160,
    renderCell: (params) => (
      <span>{params?.row?.unit_type || params?.row?.unit || "-"}</span>
    ),
  },

  {
    ...commonProps,
    field: "is_variation",
    headerName: "السمات",
    minWidth: 160,
    renderCell: (params) => (
      <span>{params?.row.is_variation ? "يوجد" : "لا يوجد"}</span>
    ),
  },
  {
    ...commonProps,
    field: "discount",
    headerName: "الخصم",
    minWidth: 160,
    renderCell: (params) => (
      <span>{params?.row?.discount ? `${params?.row?.discount} %` : "-"}</span>
    ),
  },
  {
    ...commonProps,
    field: "discount_date",
    headerName: "تاريخ انتهاء الخصم",
    minWidth: 160,
    renderCell: (params) => (
      <span>
        {params?.row?.discount_date
          ? moment(params?.row?.discount_date_to).format("DD/MM/YYYY")
          : "-"}
      </span>
    ),
  },
  // كل اللي تحت ناقص
  {
    ...commonProps,
    field: "created_at",
    headerName: "تاريخ و وقت الاضافة",
    minWidth: 160,
    renderCell: (params) => (
      <span>
        {params?.row?.created_at
          ? moment(params?.row?.created_at).format("DD/MM/YYYY hh:mm a")
          : "-"}
      </span>
    ),
  },
  {
    ...commonProps,
    field: "buy_count",
    headerName: "عدد مرات الشراء",
    minWidth: 160,
  },
  {
    ...commonProps,
    field: "favorites_count",
    headerName: "عدد مرات الاضافة للمفضلة",
    minWidth: 160,
    renderCell: (params) => {
      return (
        <span>
          {params?.row?.favorites_count || params?.row?.number_of_favorites}
        </span>
      );
    },
  },
  // {
  //   ...commonProps,
  //   field: "share_count",
  //   headerName: "عدد مرات المشاركة",
  //   minWidth: 160,
  //   renderCell: (params) => (
  //     <span className="px-2 py-1 bg-purple-50 text-purple-800 rounded">
  //       {params?.row?.share_count || 0}
  //     </span>
  //   ),
  // },
  {
    ...commonProps,
    field: "working_scope",
    headerName: "نطاق العمل",
    minWidth: 160,
    renderCell: (params) => (
      <Tooltip content={params?.row?.working_scope || "-"}>
        <span className="truncate max-w-xs px-2 py-1 bg-gray-50 text-gray-800 rounded">
          {params?.row?.working_scope || "-"}
        </span>
      </Tooltip>
    ),
  },
  // {
  //   ...commonProps,
  //   field: "appearance_count",
  //   headerName: "مدة الظهور",
  //   minWidth: 160,
  //   renderCell: (params) => {
  //     const duration = params?.row?.appearance_count;
  //     if (!duration) return "-";

  //     // Assuming duration is in days
  //     return (
  //       <span className="px-2 py-1 bg-green-50 text-green-800 rounded">
  //         {`${duration} يوم`}
  //       </span>
  //     );
  //   },
  // },
  // {
  //   ...commonProps,
  //   field: "time_remaining",
  //   headerName: "المدة المتبقية للظهور",
  //   minWidth: 160,
  //   renderCell: (params) => {
  //     const remaining = params?.row?.time_remaining;
  //     if (!remaining) return "-";

  //     // Add warning colors based on remaining time
  //     const getColorClass = (days) => {
  //       if (days <= 3) return "bg-red-50 text-red-800";
  //       if (days <= 7) return "bg-yellow-50 text-yellow-800";
  //       return "bg-green-50 text-green-800";
  //     };

  //     return (
  //       <span className={`px-2 py-1 rounded ${getColorClass(remaining)}`}>
  //         {`${remaining} يوم`}
  //       </span>
  //     );
  //   },
  // },
];
